import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@/store";
import { dynamicSlicesNames } from "@/store.constants";
import type { BmInstructionsRootStateType } from ".";
import { bmInstructionSliceName } from "./bmInstructionsSlice";
import { initialState } from "./bmInstructionsSlice";

const baseSelector = (state: RootState) => state;

// Initial state as defined in bmInstructionsSlice.ts
export const bmQueryBaseSelector = createSelector(
  baseSelector,
  (state): BmInstructionsRootStateType => {
    const slice = state[dynamicSlicesNames.BM_INSTRUCTIONS];
    return slice ?? { [bmInstructionSliceName]: initialState };
  }
);

export const bmQuerySelector = createSelector(
  bmQueryBaseSelector,
  (state) => state[bmInstructionSliceName]
);

export const bmDateRangeSelector = createSelector(
  bmQuerySelector,
  (state) => state.selectedRange
);

/**
 * Returns the query params object or undefined if not ready
 */
export const queryParamsSelector = createSelector(
  bmQuerySelector,
  ({ selectedRange, bmUnitId, filter }) => {
    const { from, to } = selectedRange;

    if (bmUnitId && from && to) {
      return { bmuid: bmUnitId, from, to, filter };
    }
    return undefined;
  }
);
